import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../Constants';
import { Navigation, NavigationItem } from '@appkit4/react-components';
import './SettingsSidebar.scss';
import { useTenantProcessTypes } from '../../helpers/useTenantProcessTypes';

const SettingsSidebar = ({ children }: any) => {
    const navigate = useNavigate();
    const { enabledSet } = useTenantProcessTypes();

    const list: any[] = [
        {
            name: 'Extraction process settings',
            url: AppRoutes.ExtractionSettings,
            prefixIcon: 'duplicate',
            itemClassName: enabledSet.has(1) ? 'enabled-row' : 'disabled-row',
            type: 1,
        },
        {
            name: 'Fill in PDF settings',
            url: AppRoutes.FillPDFSettings,
            prefixIcon: 'document-file',
            itemClassName: enabledSet.has(2) ? 'enabled-row' : 'disabled-row',
            type: 2,
        },
        {
            name: 'Fill in online form settings',
            url: AppRoutes.FillOnlineSettings,
            prefixIcon: 'circuit-board-box',
            itemClassName: enabledSet.has(3) ? 'enabled-row' : 'disabled-row',
            type: 3,
        },
    ];

    const navList: NavigationItem[] = list.map(
        ({ name, prefixIcon, itemClassName }) => ({
            name,
            prefixIcon,
            itemClassName,
        })
    );

    useEffect(() => {
        const currentIndex = list.findIndex((item) =>
            location.pathname.includes(item.url)
        );
        const isCurrentDisabled =
            currentIndex !== -1 &&
            list[currentIndex].itemClassName === 'disabled-row';
        const firstEnabledIndex = list.findIndex(
            (item) => item.itemClassName !== 'disabled-row'
        );
        if (isCurrentDisabled || currentIndex === -1) {
            if (firstEnabledIndex !== -1) {
                navigate(list[firstEnabledIndex].url);
                setselectedIndex(firstEnabledIndex);
                return;
            }
        }
        if (currentIndex !== -1) {
            setselectedIndex(currentIndex);
        } else {
            setselectedIndex(0);
        }
    }, [location, enabledSet]);

    const redirect = (
        event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
        item: NavigationItem
    ) => {
        const navItem = list.find((navItem) => item.name === navItem.name);

        if (navItem && navItem.itemClassName !== 'disabled-row') {
            navigate(navItem.url);
        }
    };

    const [selectedIndex, setselectedIndex] = useState(0);

    return (
        <div className="layout-page-container ita-sidebar">
            <div className="ap-navigation-demo-wrapper">
                <Navigation
                    hasHeader={false}
                    className="sitedemo no-border"
                    hasFooter={false}
                    solid={true}
                    showTooltip={true}
                    navList={navList}
                    hasLogo={true}
                    onClickItem={redirect}
                    selectedIndex={selectedIndex}
                ></Navigation>
            </div>
            <div className="inner-page-container">{children}</div>
        </div>
    );
};

export default SettingsSidebar;
